import { Select } from 'antd';
import React from 'react';
import { ConfigurationState, SettingsValue } from '../../../model/ConfigurationModel';
import styles from './generalSettings.module.scss';

const { Option } = Select;

// Normal properties for the component
interface Props {
	configuration: ConfigurationState;
	onSetDateFormat: (cultureCode: string) => void;
	onSetSettingValue: (value: SettingsValue<string>) => void;
	onSetSettingsHaveChanged: (value: boolean) => void;
}

const GeneralSettings: React.FC<Props> = ({ configuration, onSetDateFormat, onSetSettingValue, onSetSettingsHaveChanged }) => {
	const handleSettingChange = (value: string, key: string) => {
		if (isNaN(parseInt(value)) && key !== 'SelectedSupportedLanguage') {
			return;
		}
		const setValues: SettingsValue<string> = {
			key,
			value,
		};
		onSetSettingValue(setValues);
		if (!configuration.HaveSettingsChanged) {
			onSetSettingsHaveChanged(true);
		}
	};

	let defaultSelectedLandingPage: string = undefined;
	let selectedLandingPage = configuration.LandingPageOptions.find(x => x.Item1.toString() === configuration.SelectedLandingPage);
	if (!selectedLandingPage && configuration.LandingPageOptions.length) {
		selectedLandingPage = configuration.LandingPageOptions[0];
	}

	if (selectedLandingPage) {
		defaultSelectedLandingPage = selectedLandingPage.Item1.toString();
	}

	const dateFormat = configuration.CultureDateFormat;
	const landingPageOptions = (
		<Select
			aria-label={_('LandingPage')}
			aria-owns='LandingPage'
			aria-activedescendant='LandingPage'
			aria-controls='LandingPage'
			aria-expanded='true'
			defaultValue={defaultSelectedLandingPage}
			className={styles.selectFormatting}
			id='LandingPage'
			onChange={value => handleSettingChange(value, 'SelectedLandingPage')}>
			{configuration.LandingPageOptions.map(o => (
				<Option key={o.Item1} value={o.Item1.toString()}>
					{o.Item2}
				</Option>
			))}
		</Select>
	);

	const supportedLanguageOptions = (
		<Select
			aria-label={_('LanguageOptions')}
			aria-owns='LanguageCultureCode'
			aria-activedescendant='LanguageCultureCode'
			aria-controls='LanguageCultureCode'
			aria-expanded='true'
			defaultValue={configuration.SelectedSupportedLanguage}
			id='LanguageCultureCode'
			onChange={value => {
				onSetDateFormat(value);
				handleSettingChange(value, 'SelectedSupportedLanguage');
			}}>
			{configuration.SupportedLanguages.map(o => (
				<Option key={o.DisplayName} value={o.IsoName}>
					{o.DisplayName}
				</Option>
			))}
		</Select>
	);

	return (
		<div className={styles.container} id='ConfigTabData_0'>
			<div>
				<label htmlFor='LandingPage'>{_('LandingPage')}</label>
			</div>
			<div>{landingPageOptions}</div>
			<div>
				<label htmlFor='LanguageCultureCode'>{_('Region')}</label>
			</div>
			<div>
				{supportedLanguageOptions}
				<div className={styles.formatDate}>
					<label htmlFor='FormatDate'>
						<span id='FormatDate'>{dateFormat}</span>
					</label>
				</div>
			</div>
		</div>
	);
};

export { GeneralSettings };
